export enum ExecutionOutcome {
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}

export const dataByExecutionOutcome: Record<
  ExecutionOutcome,
  { label: string }
> = {
  [ExecutionOutcome.SUCCEEDED]: { label: "Succeeded" },
  [ExecutionOutcome.FAILED]: { label: "Failed" },
}
